import { IRootState } from 'app/shared/reducers';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { lanchPayBox } from './paybox-utiles';

export const paybox = (paymentDate) => {

    const paymentResponse: any = useSelector<IRootState>(state => state.finance.PaymentResponse);
    const email: any = useSelector<IRootState>(state => state.contract.subscriptionModel.subscriptionSelected.subscriber.email);
    const subNumber: any = useSelector<IRootState>(state => state.contract.subscriptionModel.subscriptionSelected.number);
    const retour = "Mt:M;Ref:R;trans:S;Erreur:E";

    const getRedirectPaymentUrl = () => {
        const port = location.port ? `:${location.port}` : '';
        return `${location.protocol}//${location.hostname}${port}/connect/rediriger`;
    };

    useEffect(() => {
        if (paymentResponse) {
           lanchPayBox();
           console.log("paymentResponse",paymentResponse,getRedirectPaymentUrl(),retour,subNumber + "_" + paymentResponse.numberOfScheduleLines + "_" + paymentResponse.singlePrice + "_" + paymentResponse?.paymentDateTime + "_" + paymentResponse.product)
        }
    }, [paymentResponse]);

    return (
        <>
            <div>
                <form className='payboxForm' id="frm" action={paymentResponse.action} method="post">
                    <input type="hidden" name="PBX_MODE" value={paymentResponse.mode} />
                    <input type="hidden" name="PBX_SITE" value={paymentResponse.site} />
                    <input type="hidden" name="PBX_RANG" value={paymentResponse.rang} />
                    <input type="hidden" name="PBX_IDENTIFIANT" value={paymentResponse.identifiant} />
                    <input type="hidden" name="PBX_TOTAL" value={paymentResponse.total} />
                    <input type="hidden" name="PBX_DEVISE" value="978" />
                    <input type="hidden" name="PBX_CMD" value={subNumber + "_" + paymentResponse.numberOfScheduleLines + "_" + paymentResponse.singlePrice + "_" + paymentResponse?.paymentDateTime + "_" + paymentResponse.product} />
                    <input type="hidden" name="PBX_PORTEUR" value={email} />
                    <input type="hidden" name="PBX_PAYBOX" value={paymentResponse.payBoxLink} />
                    <input type="hidden" name="PBX_BACKUP1" value={paymentResponse.payBoxLink} />
                    <input type="hidden" name="PBX_BACKUP2" value={paymentResponse.payBoxLink} />
                    <input type="hidden" name="PBX_EFFECTUE" value={getRedirectPaymentUrl()} />
                    <input type="hidden" name="PBX_REFUSE" value={getRedirectPaymentUrl()} />
                    <input type="hidden" name="PBX_ANNULE" value={getRedirectPaymentUrl()} />
                    <input type="hidden" name="PBX_REPONDRE_A" value={getRedirectPaymentUrl()} />
                    <input type="hidden" name="PBX_SOURCE" value="XHTML" />
                    <input type="hidden" name="PBX_ARCHIVAGE" value="GarantieCom" />
                    <input type="hidden" name="PBX_RETOUR" value={retour} />
                    <input type="hidden" name="PBX_HASH" value="SHA512" />
                    <input type="hidden" name="PBX_TIME" value={paymentResponse?.paymentDateTime} />
                    <input type="hidden" name="PBX_HMAC" value={paymentResponse?.hmak} />
                </form>
            </div>
        </>
    );
}
export default paybox;


